export default "__VITE_ASSET__DBWFKkAd__"